import {http} from './config';
export default {

    listarMisPedidos: () => {
        return http.get('api/mis-pedidos');
    },

    marcarRecibido: (id) => {
        return http.post('api/mis-pedidos/' + id + '/recibido');
    },

    cancelarPedido: (id) => {
        return http.post('api/mis-pedidos/' + id + '/cancelar');
    }
}
